
import { Container, Row, Col, Button } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import './ShowcaseSection.css';
import show1 from '../assets/btlatl.jpg';
import show2 from '../assets/event-8.jpg';
import show3 from '../assets/corp.jpg';
import React, { useState, useEffect } from 'react';
const eventData = {
  BTLandETL: {
    text: 'Featuring Showcase Organizing Impactful  BTL and ATL Activities.',
    description:
      'We specialize in both BTL and ATL activities—from on-ground activations and branding to mass media campaigns that drive visibility and engagement.',
    image: show1,
  },
  Weddings: {
    text: 'Plan Unforgettable Weddings with Elegant Touches.',
    description:
      'Celebrate your special day with elegance and joy. We take care of every detail for a perfect wedding.',
    image: show2,
  },
  Corporate: {
    text: 'Professional Corporate Event Management Services.',
    description:
      'Make your next corporate event a success with our expert planning and execution team.',
    image: show3,
  },
};

const ShowcaseSection = () => {
  const [activeTab, setActiveTab] = useState('BTLandETL');
  const [animationKey, setAnimationKey] = useState(0);

  const { text, description, image } = eventData[activeTab];

  useEffect(() => {
    // Increment animationKey to retrigger animation on tab change
    setAnimationKey((prev) => prev + 1);
  }, [activeTab]);

  return (
    <div className="py-5" style={{ backgroundColor: '#14092d', color: '#fff' }}>
      <Container>
        <Row className="align-items-center">
          <Col md={6} className="text-start">
            <p className="text-uppercase mb-2" style={{ color: '#f5c9d6' }}>
              Showcase
            </p>
            <h2
              key={`title-${animationKey}`}
              className="slide-up"
              style={{ color: '#f5c9d6', fontWeight: 'bold' }}
            >
              {text}
            </h2>
            <p
              key={`desc-${animationKey}`}
              className="slide-up"
              style={{ color: '#bcbcc3' }}
            >
              {description}
            </p>
            {/* rest unchanged */}
            <div className="d-flex flex-column gap-3 mt-4 mb-4">
              {Object.keys(eventData).map((key) => (
                <Button
  key={key}
  onClick={() => setActiveTab(key)}
  className="text-start px-4 py-3"
  variant={activeTab === key ? 'light' : 'outline-light'}
  style={{
    background:
      key === 'Conferences'
        ? 'linear-gradient(to right, #f5c9d6, #a67bd3)'
        : 'white',
    borderRadius: '30px',
    fontWeight: '500',
    color: key === 'BTLandETL' ? '#000' : '#000',
    border: 'none',
    display: 'flex',
    alignItems: 'center',
  }}
>
  {key === 'Weddings' && <span className="me-2">💍</span>}
  {key === 'Corporate' && <span className="me-2">🏢</span>}
  {key === 'BTLandETL' && <span className="me-2">➤</span>}
  {key}
</Button>

              ))}
            </div>
          </Col>

          <Col md={6} className="text-center position-relative">
            <img
              src={image}
              alt={activeTab}
              className="img-fluid rounded"
              style={{ maxHeight: '500px', objectFit: 'cover' }}
            />
            <div
              className="position-absolute p-3 rounded"
              style={{
                backgroundColor: '#8f43dd',
                color: 'white',
                bottom: '10%',
                left: '10%',
                maxWidth: '500px',
              }}
            >
              <div className="d-flex align-items-center">
                <span className="me-2">🔊</span>
                <div>
                  <p className="mb-0 fw-bold">Lets Talk Now</p>
                  <p className="mb-0">91 + 9657385305</p>
                </div>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default ShowcaseSection;
